/**
 * DTOs for score override operations
 * Frontend equivalents of the backend DTOs
 */

/**
 * DTO for receiving score override requests
 */
export class ScoreOverrideRequestDTO {
    /**
     * Company/Legal Entity identifier
     * @type {string}
     */
    company;

    /**
     * Fiscal Year
     * @type {string}
     */
    fiscalYear;

    /**
     * Period identifier
     * @type {string}
     */
    period;

    /**
     * Control Function identifier
     * @type {string}
     */
    ctrf;

    /**
     * New override score value
     * @type {number}
     */
    overrideScore;

    /**
     * Comment explaining the override reason
     * @type {string}
     */
    comment;

    /**
     * Username of the person performing the override
     * @type {string}
     */
    username;

    /**
     * Default constructor
     */
    constructor() {
    }

    /**
     * Constructor with all parameters
     * @param {string} company - Company/Legal Entity identifier
     * @param {string} fiscalYear - Fiscal Year
     * @param {string} period - Period identifier
     * @param {string} ctrf - Control Function identifier
     * @param {number} overrideScore - New override score value
     * @param {string} comment - Comment explaining the override reason
     * @param {string} username - Username of the person performing the override
     */
    static create(company, fiscalYear, period, ctrf, overrideScore, comment, username) {
        const dto = new ScoreOverrideRequestDTO();
        dto.company = company;
        dto.fiscalYear = fiscalYear;
        dto.period = period;
        dto.ctrf = ctrf;
        dto.overrideScore = overrideScore;
        dto.comment = comment;
        dto.username = username;
        return dto;
    }
}

/**
 * DTO for receiving multiple score override requests in a single call
 */
export class BatchScoreOverrideRequestDTO {
    /**
     * List of score overrides to save
     * @type {Array<ScoreOverrideRequestDTO>}
     */
    overrides;

    /**
     * Default constructor
     */
    constructor() {
    }

    /**
     * Constructor with overrides list
     * @param {Array<ScoreOverrideRequestDTO>} overrides - List of score override requests
     */
    static create(overrides) {
        const dto = new BatchScoreOverrideRequestDTO();
        dto.overrides = overrides;
        return dto;
    }
}


// Export ScoreOverrideRequestDTO as default for backward compatibility
export default ScoreOverrideRequestDTO;
